//Google Analytics Event Tracking
exports.analyticsEvent = function analyticsEvent(category, action, opt_label, opt_value, opt_noninteractive) {
    dataLayer.push({
        'event': 'analyticsEvent',
        'eventCategory': category,
        'eventAction': action,
        'eventLabel': opt_label,
        'eventValue': opt_value,
        'eventNonInt': opt_noninteractive
    });
};

//Google Analytics Social Interaction Tracking
exports.socialInteraction = function socialInteraction(socialNetwork, socialAction, opt_socialTarget, opt_page) {
    dataLayer.push({
        'event': 'social',
        'socialNetwork': socialNetwork,
        'socialAction': socialAction,
        'socialTarget': opt_socialTarget,
        'socialPagePath': opt_page
    });
};


//////////////////
// WEBPACK FOOTER
// ./public/js/lib/gtm-events.js
// module id = 4
// module chunks = 0